import LegalLayout, { P, H2, UL } from "./LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms &amp; Conditions" updated="February 2026">
      <P>By creating a Vendorly account or using grahakly.app, you agree to these terms. If you do not agree, do not use the service.</P>

      <H2>1. The service</H2>
      <P>Vendorly is a Software-as-a-Service (SaaS) platform that lets small business owners collect customer contact details via a printed QR code and send WhatsApp campaigns using Meta-approved message templates.</P>

      <H2>2. Eligibility</H2>
      <UL>
        <li>You must be at least 18 years old.</li>
        <li>You must be legally authorised to run the business you register under.</li>
        <li>Your business must operate within Indian law.</li>
      </UL>

      <H2>3. Vendor obligations</H2>
      <UL>
        <li>You are the data controller for your customer list. You must have a lawful basis (usually clear consent at the point of QR scan) to store their number and message them.</li>
        <li>You must not use Vendorly to send illegal content, financial scams, adult content, gambling promotions, or unsolicited spam.</li>
        <li>You must honour every "STOP" reply within 24 hours.</li>
        <li>You are responsible for keeping your login credentials confidential.</li>
      </UL>

      <H2>4. Prohibited use</H2>
      <P>Accounts that send fraud, phishing, adult content, gambling, or messages violating Meta's WhatsApp Business Policy will be suspended immediately without refund and reported to Twilio and Meta.</P>

      <H2>5. Subscription &amp; billing</H2>
      <UL>
        <li>First month: ₹99 (introductory offer, one-time per account).</li>
        <li>Subsequent months: ₹199 per month, billed per renewal.</li>
        <li>No automatic renewal — you must manually renew each cycle. If not renewed, your account moves to "read-only" mode until you pay again.</li>
        <li>All amounts are in Indian Rupees and inclusive of applicable taxes unless stated otherwise.</li>
        <li>Payments are processed by Razorpay. Card, UPI, netbanking and wallet details are handled by Razorpay directly — we do not see or store card data.</li>
      </UL>

      <H2>6. Free tier</H2>
      <P>Every new vendor gets 1 free WhatsApp campaign (unlimited recipients within that campaign) before a subscription is required.</P>

      <H2>7. Cancellation</H2>
      <P>You may cancel at any time by not renewing. To permanently delete your account and data, email us — see our Refund Policy for financial terms.</P>

      <H2>8. Service availability</H2>
      <P>We aim for 99% monthly uptime, but Vendorly is provided "as is" without warranty of uninterrupted service. Scheduled maintenance windows will be announced 24 hours in advance where possible. Downtime longer than 24 continuous hours in a billing cycle qualifies for a pro-rata credit on the next invoice.</P>

      <H2>9. Third-party services</H2>
      <P>Vendorly depends on Twilio (WhatsApp delivery), Meta (template approval), Razorpay (payments), and Resend (email). Their outages are outside our control. We are not liable for lost revenue caused by upstream outages.</P>

      <H2>10. Limitation of liability</H2>
      <P>To the maximum extent permitted by Indian law, Vendorly's total liability to any vendor in any 12-month period is limited to the total amount paid by that vendor to us in the preceding 12 months. We are not liable for indirect, incidental, or consequential damages including lost profits, lost customers, or lost data.</P>

      <H2>11. Intellectual property</H2>
      <P>The Vendorly name, logo, source code, dashboard designs, and QR poster templates are our intellectual property. You retain full ownership of your customer list, business content, and any custom message drafts you create.</P>

      <H2>12. Governing law &amp; jurisdiction</H2>
      <P>These terms are governed by the laws of India. Any dispute arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of courts in Gorakhpur, Uttar Pradesh, India.</P>

      <H2>13. Changes to these terms</H2>
      <P>We may amend these terms. Material changes will be emailed to registered vendors at least 7 days in advance. Continued use after the change takes effect constitutes acceptance.</P>

      <H2>14. Contact</H2>
      <P>Questions about these terms? Email <a href="mailto:vendorlyadmin@gmail.com" className="text-brand-primary font-semibold">vendorlyadmin@gmail.com</a>.</P>
    </LegalLayout>
  );
}
